// src/components/Dashboard_ADM/Atendimento/index.tsx
// Hub único "Atendimento" — sub-abas internas: Conversas | Funil | Leads | Métricas | Configurações | Disparos
// (seção 8 do relatório CRM v3.0 — tudo dentro do mesmo painel admin, mesmo login)

import React, { useState } from 'react';
import { MessageCircle, GitBranch, Users, BarChart3, Settings2, Send, Workflow } from 'lucide-react';
import ConversasTab from './ConversasTab';
import FunilTab from './FunilTab';
import LeadsTab from './LeadsTab';
import MetricasTab from './MetricasTab';
import ConfiguracoesTab from './ConfiguracoesTab';
import DisparosTab from './DisparosTab';
import FluxosTab from './FluxosTab';

const TABS = [
  { id: 'conversas', label: 'Conversas', icon: MessageCircle, component: ConversasTab },
  { id: 'funil', label: 'Funil', icon: GitBranch, component: FunilTab },
  { id: 'leads', label: 'Leads', icon: Users, component: LeadsTab },
  { id: 'fluxos', label: 'Fluxos', icon: Workflow, component: FluxosTab },
  { id: 'metricas', label: 'Métricas', icon: BarChart3, component: MetricasTab },
  { id: 'configuracoes', label: 'Configurações', icon: Settings2, component: ConfiguracoesTab },
  { id: 'disparos', label: 'Disparos', icon: Send, component: DisparosTab },
] as const;

type TabId = (typeof TABS)[number]['id'];

const Atendimento: React.FC = () => {
  const [tabAtiva, setTabAtiva] = useState<TabId>('conversas');
  const TabComponent = TABS.find((t) => t.id === tabAtiva)?.component ?? ConversasTab;

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-2xl border border-gray-200 p-2 flex gap-1 overflow-x-auto">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const ativo = tabAtiva === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setTabAtiva(tab.id)}
              className={`flex items-center gap-2 px-4 py-2.5 rounded-xl font-bold text-sm whitespace-nowrap transition-all flex-shrink-0 ${
                ativo ? 'bg-gray-900 text-white shadow-md' : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Icon className="w-4 h-4" /> {tab.label}
            </button>
          );
        })}
      </div>

      <TabComponent />
    </div>
  );
};

export default Atendimento;
